import React from "react";
import { MVCSubmitButton } from "Views/MVCForm";
import { SmallIcon } from "./SmallIcon";

export function BulmaNavButtons(props: {
  backCaption?: React.ReactNode;
  backValue?: string;
  backIcon?: React.ReactNode;
  continueCaption?: React.ReactNode;
  continueValue?: string;
  hideContinueIcon?: boolean;
  isDisabled?: boolean;
}) {
  const continueValue = props.continueValue || "continue";
  const backValue = props.backValue || "back";
  return (
    <div
      id="nav-button-section"
      className="field is-grouped is-grouped-centered is-grouped-multiline"
      style={{ marginTop: "1.5em" }}
    >
      {props.backCaption && (
        <div className="control">
          <MVCSubmitButton
            className="button"
            value={backValue}
            disabled={props.isDisabled}
          >
            {props.backIcon || <SmallIcon name="fa-arrow-left" />}
            <span>{props.backCaption}</span>
          </MVCSubmitButton>
        </div>
      )}
      {props.continueCaption && (
        <div className="control">
          <MVCSubmitButton
            id="SubmitButton"
            className="button"
            value={continueValue}
            disabled={props.isDisabled}
            isPrimary
          >
            <span>{props.continueCaption}</span>
            {!props.hideContinueIcon && <SmallIcon name="fa-arrow-right" />}
          </MVCSubmitButton>
        </div>
      )}
    </div>
  );
}
